/* unplugin-vue-components disabled */import { render } from "./menu-title.vue?vue&type=template&id=0d9d766a"
import script from "./menu-title.vue?vue&type=script&lang=js"
export * from "./menu-title.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wuxieshuan/Desktop/上海印高/WeCom_FE/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/basic-layout/menu-side/menu-title.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d9d766a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d9d766a', __exports__)) {
    console.log('reload')
    api.reload('0d9d766a', __exports__)
  }
  
  module.hot.accept("./menu-title.vue?vue&type=template&id=0d9d766a", () => {
    console.log('re-render')
    api.rerender('0d9d766a', render)
  })

}


export default __exports__